import type { ButtonHTMLAttributes } from "react";

function EditIcon() {
  return (
    <svg
      viewBox="0 0 16 16"
      width="15"
      height="15"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="m10.6 3.4 2 2M4 12l.55-2.7 6.8-6.8 2.15 2.15-6.8 6.8L4 12Z" />
    </svg>
  );
}

export function EditButton({
  label,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> & {
  label: string;
}) {
  return (
    <button
      {...props}
      type="button"
      className="ui-edit-action"
      aria-label={label}
      title={label}
    >
      <EditIcon />
    </button>
  );
}
